var _ellipse, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 64.2977,
    rx: 64,
    ry: 64.2977,
    fill: "#304564"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1647_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1317 39.2123C50.1317 36.3336 52.5849 34 55.6111 34H73.2479C76.2741 34 78.7274 36.3336 78.7274 39.2123C78.7274 42.0909 76.2741 44.4246 73.2479 44.4246H55.6111C52.5849 44.4246 50.1317 42.0909 50.1317 39.2123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4262 48.5781C42.4262 43.9902 46.336 40.271 51.159 40.271H77.8711C82.6941 40.271 86.604 43.9902 86.604 48.5781V62.749L87.9772 77.3183C88.4354 82.1795 84.4101 86.3672 79.2793 86.3672H50.3382C45.338 86.3672 41.3587 82.3811 41.617 77.631L42.4262 62.749V48.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7624 74.8021C35.162 73.9328 35.9854 73.3022 36.9616 73.1075L40.4009 72.4215C40.6089 72.3801 40.8209 72.3591 41.0334 72.3591H87.8689C88.0525 72.3591 88.2358 72.3748 88.4165 72.4058L92.2703 73.0677C93.5033 73.2795 94.4942 74.1783 94.7232 75.35C95.1038 77.2978 95.1399 78.4811 94.5258 80.1279C94.3922 80.4861 94.3093 80.8617 94.3093 81.2418V92.0681C94.3093 93.6873 92.9293 95 91.2271 95H38.4877C36.7855 95 35.4056 93.6873 35.4056 92.0681V81.4934C35.4056 80.9525 35.2417 80.423 34.9614 79.9524C33.6202 77.7014 33.8052 76.8849 34.7624 74.8021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.104 48.5781C87.104 44.1216 83.647 40.4695 79.1895 39.8604C79.2145 39.6478 79.2274 39.4316 79.2274 39.2123C79.2274 36.0342 76.5264 33.5 73.2479 33.5H55.6111C52.3326 33.5 49.6317 36.0342 49.6317 39.2123C49.6317 39.44 49.6455 39.6644 49.6725 39.8849C45.2965 40.5618 41.9262 44.1778 41.9262 48.5781V62.7354L41.4301 71.8591H41.0334C40.7881 71.8591 40.5434 71.8833 40.3031 71.9312L36.8638 72.6172C35.7399 72.8414 34.7785 73.5699 34.3081 74.5933C33.8337 75.6256 33.498 76.4448 33.5 77.3154C33.5021 78.1991 33.8487 79.0618 34.5318 80.2084C34.7723 80.6119 34.9056 81.054 34.9056 81.4934V92.0681C34.9056 93.9867 36.5332 95.5 38.4877 95.5H91.2271C93.1816 95.5 94.8093 93.9867 94.8093 92.0681V81.2418C94.8093 80.9341 94.8766 80.6183 94.9943 80.3026C95.6526 78.5372 95.6042 77.2515 95.2139 75.2541C94.9408 73.8567 93.7696 72.8179 92.355 72.5749L88.5012 71.913C88.324 71.8826 88.1448 71.865 87.965 71.8604L87.104 62.7255V48.5781Z",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.8673,
    y: 84.3062,
    width: 52.1531,
    height: 7.95918,
    rx: 2,
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 75.5919,
    width: 55.2653,
    height: 3.60204,
    rx: 1.80102,
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8062 38.2408C53.8062 37.5555 54.3617 37 55.047 37H74.2184C74.9037 37 75.4592 37.5555 75.4592 38.2408C75.4592 38.5136 75.2381 38.7347 74.9653 38.7347H54.3C54.0273 38.7347 53.8062 38.5136 53.8062 38.2408Z",
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 1.86735
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5817 55.4694C47.5817 49.3943 52.5065 44.4694 58.5817 44.4694H71.3062C77.3813 44.4694 82.3062 49.3943 82.3062 55.4694V66.4796C82.3062 68.6888 80.5153 70.4796 78.3062 70.4796H51.5817C49.3725 70.4796 47.5817 68.6888 47.5817 66.4796V55.4694Z",
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.8673,
    y: 84.3062,
    width: 52.1531,
    height: 7.95918,
    rx: 2,
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 75.5919,
    width: 55.2653,
    height: 3.60204,
    rx: 1.80102,
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8062 38.2408C53.8062 37.5555 54.3617 37 55.047 37H74.2184C74.9037 37 75.4592 37.5555 75.4592 38.2408C75.4592 38.5136 75.2381 38.7347 74.9653 38.7347H54.3C54.0273 38.7347 53.8062 38.5136 53.8062 38.2408Z",
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 1.86735
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5817 55.4694C47.5817 49.3943 52.5065 44.4694 58.5817 44.4694H71.3062C77.3813 44.4694 82.3062 49.3943 82.3062 55.4694V66.4796C82.3062 68.6888 80.5153 70.4796 78.3062 70.4796H51.5817C49.3725 70.4796 47.5817 68.6888 47.5817 66.4796V55.4694Z",
    fill: "#304564",
    stroke: "#304564",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1647_137",
    x: 29,
    y: 33,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1647_137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1647_137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatInfo);
export default __webpack_public_path__ + "static/media/seatInfo.98c71bd3168292fb592469cd08baa2a5.svg";
export { ForwardRef as ReactComponent };